import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class UnsavedTrackingService {

  private initialValues = new WeakMap<FormGroup, any>();
  private bypassUnsavedCheck = false;

  registerForm(form: FormGroup) {
    this.initialValues.set(form, this.clone(form.getRawValue()));
  }

  hasChanges(form: FormGroup): boolean {
    if (this.bypassUnsavedCheck) {
      return false;
    }

    const initial = this.initialValues.get(form);
    if (!initial) return false;

    return JSON.stringify(initial) !==
      JSON.stringify(this.clone(form.getRawValue()));
  }

  markSaved(form: FormGroup) {
    this.initialValues.set(form, this.clone(form.getRawValue()));
  }

  bypassCheck(): void {
    this.bypassUnsavedCheck = true;
  }

  enableCheck(): void {
    this.bypassUnsavedCheck = false;
  }

  private clone(value: any) {
    return JSON.parse(JSON.stringify(value));
  }

  hasAnyChanges(): boolean {
    return false;
  }
}